import angular from 'angular';

function IsolateFormDirective() {
  //copied from https://github.com/nmutalik/isolate-form/blob/master/index.js
  return {
    restrict: 'A',
    require: 'form',
    priority: 1,
    link(scope, elm, attrs, ctrl) {
      // Do a copy of the controller
      const ctrlCopy = {};
      angular.copy(ctrl, ctrlCopy);

      // Get the parent of the form
      const parent = elm.parent().controller('form');
      // Remove parent link to the controller
      parent.$removeControl(ctrl);

      // Replace form controller with a "isolated form"
      const isolatedFormCtrl = {
        $setValidity: function (validationToken, isValid, control) {
          ctrlCopy.$setValidity(validationToken, isValid, control);
          parent.$setValidity(validationToken, true, ctrl);
        },
        $setDirty: function () {
          elm.removeClass('ng-pristine').addClass('ng-dirty');
          ctrl.$dirty = true;
          ctrl.$pristine = false;
        }
      };
      angular.extend(ctrl, isolatedFormCtrl);
    }
  };
}

IsolateFormDirective.$inject = [];

export default IsolateFormDirective;



// WEBPACK FOOTER //
// ./src/directives/isolateForm.js